import { packageScheduledChangeActionTypes as actionTypes } from '../../ActionTypes/Voss/packageScheduledChangeActionTypes';
import { apiThunk } from '../../Utils/apiThunk';
import { mutatePackageResource, packageResourceUrl } from './packageResourceApi';
import type { AppDispatch } from '../../Store/types';
import type { PackageScheduledChange, PackageScheduledChangeRequest } from '../../Components/Voss/Packages/Packages.types';

const SCHEDULED_CHANGES_LOADING_KEY = 'packageScheduledChanges';

const scheduledChangeUrl = (packageId: string, versionId: string | undefined, scheduledChangeId?: string) =>
    packageResourceUrl(packageId, 'scheduledChanges', versionId, scheduledChangeId);

// the scheduled changes embedded in GET /api/packages/{id} are not refreshed by writes, so the tab is fed from its own endpoint
const fetchScheduledChanges = (packageId: string, versionId: string | undefined) => (dispatch: AppDispatch) =>
    dispatch(apiThunk<PackageScheduledChange[]>(scheduledChangeUrl(packageId, versionId), { loadingKey: SCHEDULED_CHANGES_LOADING_KEY })).then((data) => {
        if (data !== null) dispatch({ type: actionTypes.STORE_PACKAGE_SCHEDULED_CHANGES, data: { versionId, changes: data } });
    });

// resolves true once the write succeeded and the list is being refreshed, false if it failed (the toast has already been shown)
const changeScheduledChange = (packageId: string, versionId: string | undefined, url: string, init: RequestInit) => (dispatch: AppDispatch) =>
    dispatch(mutatePackageResource(url, init)).then((succeeded) => {
        if (succeeded) void dispatch(fetchScheduledChanges(packageId, versionId));

        return succeeded;
    });

const packageScheduledChangeActions = {
    fetchScheduledChanges,

    clearScheduledChanges() {
        return { type: actionTypes.CLEAR_PACKAGE_SCHEDULED_CHANGES };
    },

    createScheduledChange(packageId: string, model: PackageScheduledChangeRequest, versionId: string | undefined) {
        return changeScheduledChange(packageId, versionId, scheduledChangeUrl(packageId, versionId), { method: 'POST', body: JSON.stringify(model) });
    },

    updateScheduledChange(packageId: string, scheduledChangeId: string, model: PackageScheduledChangeRequest, versionId: string | undefined) {
        return changeScheduledChange(packageId, versionId, scheduledChangeUrl(packageId, versionId, scheduledChangeId), { method: 'PUT', body: JSON.stringify(model) });
    },

    // VOSS cancels a pending change with DELETE on the resource; the row stays in the list as Cancelled
    cancelScheduledChange(packageId: string, scheduledChangeId: string, versionId: string | undefined) {
        return changeScheduledChange(packageId, versionId, scheduledChangeUrl(packageId, versionId, scheduledChangeId), { method: 'DELETE' });
    },
};

export default packageScheduledChangeActions;
